<form [formGroup]="service.playerForm" (submit)="dialogRef.close()">
  <div mat-dialog-title><h2>BUSCAR JUGADOR</h2></div>
  <mat-dialog-content>
    <!--Form player-->
    <mat-form-field>
      <mat-label>Jugador</mat-label>
      <input cdkFocusInitial matInput #playerInput placeholder="Select player" formControlName="player" (keydown.enter)="handleEnter($event, playerAuto)"
          [matAutocomplete]="playerAuto" (input)="filter(playerInput)" (focus)="filter(playerInput)">
      <mat-autocomplete #playerAuto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onPlayerSelected(playerInput)">
          <mat-option *ngFor="let player of filteredPlayers" [value]="player">{{player?.name}}</mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <section *ngIf="data=='Lineup'">
      <!--Form change player name-->
      <section *ngIf="auth.isEditor()">
        <h3>Crea un jugador nuevo</h3>
        <mat-form-field>
          <mat-label>Nombre del jugador</mat-label>
          <input #player_name type="text" placeholder="Insert name" matInput formControlName="player_name">
        </mat-form-field>
      </section>

      <!--Substitute
      <h3>Añadir suplente</h3>
      <mat-form-field>
        <mat-label>Nombre del suplente</mat-label>
        <input #sub_name type="text" placeholder="Insert name" matInput formControlName="sub_name">
      </mat-form-field>
       -->

      <!--Sub player-->
      <h3>Jugador suplente</h3>
      <mat-form-field>
        <mat-label>Suplente</mat-label>
        <input cdkFocusInitial matInput #subInput placeholder="Select player" formControlName="sub_player" (keydown.enter)="handleEnter($event, subAuto)"
            [matAutocomplete]="subAuto" (input)="filter(subInput)" (focus)="filter(subInput)">
        <mat-autocomplete #subAuto="matAutocomplete" [displayWith]="displayFn">
          <mat-option *ngFor="let player of filteredPlayers" [value]="player">{{player?.name}}</mat-option>
        </mat-autocomplete>
      </mat-form-field>

    </section>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="warn" mat-dialog-close (click)="service.playerForm.reset()">Cancel</button>
    <button mat-button type="submit">Add</button>
  </mat-dialog-actions>
</form>